module.exports = "/_next/static/images/b7badad05921897f4abd669f5fa18ce4-hero-lg.jpg.webp";